import {
  dateFormats,
  dateTime,
  formatDate,
} from '../../../../../shared/packages/dateTime';

class Component {
  constructor({ date, id, name }) {
    this.date = date;
    this.id = id;
    this.name = name;
  }

  setParent(parent) {
    this.parent = parent;
  }

  getParent() {
    return this.parent;
  }

  isComposite() {
    return false;
  }
}

class Composite extends Component {
  constructor(payload) {
    super(payload);
    this._childIndexById = new Map();
    this.children = [];
    this.add(payload);
  }

  isComposite() {
    return true;
  }

  add(payload) {}

  getChildById(id) {
    const index = this._childIndexById.get(id);
    return this.children[index];
  }
}

class Month extends Composite {
  add({ date }) {
    const id = formatDate(date, dateFormats.ISO);

    const index = this._childIndexById.get(id);

    if (index === undefined) {
      this._childIndexById.set(id, this.children.length);

      const child = new Component({ date, id });
      child.setParent(this);
      this.children.push(child);
    }
  }

  isComposite() {
    return true;
  }
}

class Year extends Composite {
  add({ date }) {
    const id = date.month();

    const index = this._childIndexById.get(id);

    if (index === undefined) {
      const localeData = date.localeData();
      const name = localeData.monthsShort(date);

      this._childIndexById.set(id, this.children.length);

      const child = new Month({ date, id, name });
      child.setParent(this);

      this.children.push(child);
    } else {
      this.children[index].add({ date });
    }
  }

  isComposite() {
    return true;
  }
}

export class Collection {
  constructor(data) {
    this.collection = new Map();

    data.forEach((el) => {
      const date = dateTime(el.value);
      const year = date.year();

      const yearData = getOrInsert(
        this.collection,
        year,
        () => new Year({ date, id: year, name: year })
      );

      yearData.add({ date });
    });
  }

  getYears() {
    if (!this.years) {
      this.years = Array.from(this.collection.values());
    }

    return this.years;
  }

  getDate({ dateTime, dateStr }) {
    const year = dateTime.year();
    const month = dateTime.month();
    return this.collection
      .get(year)
      ?.getChildById(month)
      ?.getChildById(dateStr);
  }

  getValue(data) {
    return data.isComposite() ? this.getFirstDate(data) : data;
  }

  getFirstDate(data) {
    return this._getFirstLeaf(data ?? this.getYears()[0]);
  }

  _getFirstLeaf(data) {
    const target = data.children[0];

    return target.isComposite() ? this._getFirstLeaf(target) : target;
  }

  getDefaultDate() {
    const date = dateTime();
    return new Component({
      date,
      id: formatDate(date, dateFormats.ISO),
    });
  }
}

function getOrInsert(map, key, creator) {
  if (!map.has(key)) {
    map.set(key, creator());
  }

  return map.get(key);
}
